/* @flow */
import React from 'react';
import Time from 'components/Time.jsx';

type Props = {
  start: Date,
  end?: ?Date,
};

export default function TimeRange(props: Props) {
  const { start, end, ...timeProps } = props;

  // Copy props for start and end
  const startProps = Object.assign({}, timeProps);
  const endProps = Object.assign({}, timeProps);

  startProps.date = start;

  // If end is null, just proxy to Time
  if (!end) {
    return <Time {...startProps} />;
  }

  endProps.date = end;

  // Check if start and end have same calendar day
  if (start.getDate() === end.getDate() &&
    start.getMonth() === end.getMonth() &&
    start.getFullYear() === end.getFullYear()) {
    // Date is the same, so don't show date in end Time component
    delete endProps.year;
    delete endProps.month;
    delete endProps.day;
  }

  return (
    <span className="TimeRange">
      <Time {...startProps} />
      { ' - ' }
      <Time {...endProps} />
    </span>
  );
}



// WEBPACK FOOTER //
// ./src/components/TimeRange.jsx